import * as React from "react";
const ClothesExtraCorporateMale = () => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1920">
		<defs>
			<style>
				{
					".cls-extra-corp-mal-1{fill:none;}.cls-extra-corp-mal-2{fill:#282b2e;}.cls-extra-corp-mal-3{fill:#213a49;}.cls-extra-corp-mal-4{clip-path:url(#clip-path-extra-corp-mal);}.cls-extra-corp-mal-5{fill:#304d5d;}.cls-extra-corp-mal-6{fill:#f26962;}.cls-extra-corp-mal-7{fill:#fefefe;}.cls-extra-corp-mal-8{fill:#f3eff4;}.cls-extra-corp-mal-9{fill:#fbfbfb;}"
				}
			</style>
			<clipPath id="clip-path-extra-corp-mal">
				<path
					className="cls-extra-corp-mal-1"
					d="M817.36,672.65c-4.2-25.2-29.4-197.4-33.6-218.4s-8.4-33.6-23.1-50.4-86.1-42-102.9-46.2c-10.5-29.4-39.9-35.7-39.9-35.7-2.1,27.3-42,42-54.59,42s-52.5-14.7-54.6-42c0,0-29.4,6.3-39.9,35.7-16.8,4.2-88.2,29.4-102.9,46.2s-18.9,29.4-23.1,50.4-29.4,193.2-33.6,218.4-33.6,182.7-12.6,279.3c10.5,14.7,65.1,4.2,65.1,4.2s8.4-81.9,8.4-105,39.32-195.49,42-214.2c2-14,.19-41.23,0-43.87l10.49,151s-21,144.9-14.7,186.9c25.2,8.4,75.6,29.4,132.3,0,10.5-6.3,23.1-21,23.1-21s12.6,14.7,23.1,21c56.69,29.4,107.09,8.4,132.29,0,6.3-42-14.7-186.9-14.7-186.9L714.46,593c-.14,1.91-2,29.8,0,44,2.68,18.71,42,191.1,42,214.2s8.4,105,8.4,105,54.6,10.5,65.1-4.2C851,855.35,821.56,697.85,817.36,672.65Z"
				/>
			</clipPath>
		</defs>
		<title>{"habit corporate ++ m"}</title>
		<g id="Calque_1" data-name="Calque 1">
			<rect className="cls-extra-corp-mal-1" width={1080} height={1920} />
		</g>
		<g id="corporate_m" data-name="corporate ++ m">
			<path
				className="cls-extra-corp-mal-2"
				d="M519.52,1734.37l1.75,60.18s14.7,37.8,14.7,46.2a51.28,51.28,0,0,1-2.1,14.7s-25.2,12.6-54.6,12.6-58.8-12.6-58.8-12.6-4.2-23.1,0-29.4,25.2-60.9,25.2-60.9l1.55-29.62,29.95-8.18Z"
			/>
			<path
				className="cls-extra-corp-mal-2"
				d="M607.25,1734.37l-1.75,60.18s-14.7,37.8-14.7,46.2a51.28,51.28,0,0,0,2.1,14.7s25.2,12.6,54.6,12.6,58.8-12.6,58.8-12.6,4.2-23.1,0-29.4-25.2-60.9-25.2-60.9l-1.55-29.62-29.95-8.18Z"
			/>
			<path
				className="cls-extra-corp-mal-3"
				d="M727.06,1096.85c0-25.2-14.7-252-14.7-252l-149.09,12.6-149.1-12.6s-14.7,226.8-14.7,252,12.6,218.4,8.4,241.5-6.3,165.9,2.1,224.7,21,172.2,21,172.2,21,14.7,60.9,10.5,33.6-10.5,33.6-10.5-2.69-277.27,0-296.1c2.1-14.7,8.4-60.9,12.6-102.9,5.22-52.28,18.9-245.7,18.9-245.7s2.1-52.5,4.2-52.5h4.2c2.1,0,4.2,52.5,4.2,52.5s13.67,193.42,18.9,245.7c4.2,42,10.5,88.2,12.6,102.9,2.68,18.83,0,296.1,0,296.1s-6.3,6.3,33.59,10.5,60.9-10.5,60.9-10.5,12.6-113.4,21-172.2,6.3-201.6,2.1-224.7S727.06,1122.05,727.06,1096.85Z"
			/>
			<g className="cls-extra-corp-mal-4">
				<path
					className="cls-extra-corp-mal-5"
					d="M817.36,672.65c-4.2-25.2-29.4-197.4-33.6-218.4s-8.4-33.6-23.1-50.4-86.1-42-102.9-46.2c-10.5-29.4-39.9-35.7-39.9-35.7-2.1,27.3-42,42-54.59,42s-52.5-14.7-54.6-42c0,0-29.4,6.3-39.9,35.7-16.8,4.2-88.2,29.4-102.9,46.2s-18.9,29.4-23.1,50.4-29.4,193.2-33.6,218.4-33.6,182.7-12.6,279.3c10.5,14.7,65.1,4.2,65.1,4.2s8.4-81.9,8.4-105S407.33,654.71,410,636c2-14,2.26-40.28,2.08-42.92l10.49,151s-21,144.9-14.7,186.9c25.2,8.4,75.6,29.4,132.3,0,10.5-6.3,23.1-21,23.1-21s12.6,14.7,23.1,21c56.69,29.4,107.09,8.4,132.29,0,6.3-42-14.7-186.9-14.7-186.9L714.46,593c-.14,1.91-.49,30.85,1.54,45,2.67,18.71,40.46,190,40.46,213.15s8.4,105,8.4,105,54.6,10.5,65.1-4.2C851,855.35,821.56,697.85,817.36,672.65Z"
				/>
				<polygon
					className="cls-extra-corp-mal-6"
					points="554.87 576.05 521.26 479.45 546.47 370.25 584.26 366.05 605.26 489.95 571.66 565.55 554.87 576.05"
				/>
				<path
					className="cls-extra-corp-mal-7"
					d="M622.06,311.45l-58.79,39.9-58.8-39.9-12.6,84,48.3,27.3,6.3-12.6s2.1-37.8,16.8-39.9c14.7,2.1,16.8,39.9,16.8,39.9l6.3,12.6,48.29-27.3Z"
				/>
				<path
					className="cls-extra-corp-mal-8"
					d="M573.77,571.85l-23.1-6.3-50.4-210s4.2,54.6,46.2,50.4c0-6.3,0-8.4,2.1-12.6a62.13,62.13,0,0,0,6.3,8.4l-12.6,92.4,16.8,69.3h8.4l21-71.4-14.7-90.3,4.2-8.4s6.3,0,2.1,12.6c12.6,2.1,26.09,1.54,40.34-23.38S632.56,343,632.56,343l-29.39,180.6Z"
				/>
				<path
					className="cls-extra-corp-mal-3"
					d="M469.35,356.11S452,391.25,456.17,435.35l50.4,12.6s-23.1,21-27.3,37.8c12.6,25.2,42,84,73.5,111.3,4.2,4.2,25.2,31.5,25.2,46.2s4.2-12.6,4.2-21c0-1.79-2.2-10.34-5.71-22.86-.83-3,81.3-94.74,75-113.64-1.06-3.19-10.5-23.1-31.5-37.8,11-1.29,35.62-5.21,50.4-12.6,1.06-4.21,0-111.3-52.5-113.4,18.9,25.2-4.2,81.9-8.4,96.6C596.19,465,565.75,562.46,564.78,559.21c-14.52-48.79-33.43-109.57-37.21-119.66-6.3-16.8-18.9-50.4-21-67.2s-2.1-44.1,6.3-63-50.4,23.1-50.4,23.1Z"
				/>
				<circle
					className="cls-extra-corp-mal-9"
					cx={563.27}
					cy={645.35}
					r={6.3}
				/>
				<circle
					className="cls-extra-corp-mal-9"
					cx={563.27}
					cy={788.15}
					r={6.3}
				/>
				<path
					className="cls-extra-corp-mal-3"
					d="M643.06,750.35s31.5,4.2,69.3-6.3-4.2,14.7-4.2,14.7a346.71,346.71,0,0,1-65.1,6.3Z"
				/>
				<path
					className="cls-extra-corp-mal-3"
					d="M483.47,750.35s-31.5,4.2-69.3-6.3,4.2,14.7,4.2,14.7a346.71,346.71,0,0,0,65.1,6.3Z"
				/>
			</g>
		</g>
	</svg>
);
export default ClothesExtraCorporateMale;
